<template>
    <a :href="data.link" class="card school-card threads__row">

        <!-- CONTENT -->
        <div class="school-card__content">
            <div class="card__title school-card__name">{{ data.name }}</div>
            <div class="card__meta school-card__meta meta meta--small">
                <span class="meta__school">{{ data.type }}</span>
                <span class="meta__land meta--sep-dash">{{ data.country }}, {{ data.city }}</span>
            </div>
        </div>

        <!-- COMMENTS -->
        <div class="thread-card__comments">
            <div class="avatar__collection">
                <span class="avatar avatar--small" v-for="(author, index) in data.authors.avatars" :style="setIndex(index)">
                    <img class="avatar__image" v-if="hasAvatar(author)" :src="author">
                    <span class="avatar__initials" v-if="!hasAvatar(author)">{{ author }}</span>
                </span>
                <div class="avatar avatar--small" v-if="data.authors.total > 0" style="transform: translateX(0); z-index: 1;">
                    <span class="avatar__amount">{{ data.authors.total }}+</span>
                </div>
            </div>
        </div>

    </a>
</template>

<script>

    export default {

        name: 'School',

        /* ----------------------------------------
            Data
        ---------------------------------------- */

        /**
         * If needed set debug to true to display
         * values (ids) of related filter values.
         */

        data() {
            return {
                debug: false
            }
        },

        /* ----------------------------------------
            Methods
        ---------------------------------------- */

        methods: {

            /* ----------------------------------------
                Set Index
            ---------------------------------------- */

            /**
             * Will generate styling for author images
             * based on a given offset. Avatars are will
             * presume that only 3 items are added within
             * the data object of the given feed.
             */

            setIndex(index) {
                const length = this.data.authors.avatars.length;
                const total = this.data.authors.total;

                const offset = length === 3 && total > 0 ? 1 : 0;
                const translateX = -Math.abs((length * 1.9 * offset) - (1.9 * index)) + 'em';
                const zIndex = length - index + offset;

                return `transform: translateX(${ translateX }); z-index: ${ zIndex }`;
            },

            /* ----------------------------------------
                Has Avatar
            ---------------------------------------- */

            /**
             * Will check if given string is an image
             */

            hasAvatar(src) {
                if (!src) { return null }
                return src.match(/\.(jpeg|jpg|gif|png)$/) != null;
            }

        },

        /* ----------------------------------------
            Props
        ---------------------------------------- */

        /**
         * The data object contains all the information
         * that has to be displayed within the render
         * of this card element.
         */

        props: ['data']

    };
</script>